module.exports = __webpack_public_path__ + "img/richengqr.fb961cbb.png";